import React from 'react';
import './ProgressBar.scss';
export var ProgressBar = function (_a) {
    var index = _a.index, completed = _a.completed, _b = _a.barWidth, barWidth = _b === void 0 ? 100 : _b;
    var progressWidth = index > 0
        ? (completed / 100) * barWidth
        : (completed / 100) * (barWidth / 2) + barWidth / 2;
    var calcBarWidth = index > 0 ? barWidth : "".concat(barWidth, " - 50%");
    return (React.createElement("div", { style: {
            width: "calc(".concat(calcBarWidth, " / 2)"),
        }, className: "ProgressBarSection sui-flex sui-flex-col sui-justify-center sui-align-center" },
        React.createElement("div", { className: "ProgressBarContainer sui-flex sui-flex-row sui-justify-start sui-align-start" },
            React.createElement("div", { style: {
                    width: "calc(".concat(progressWidth, "% - 10%)"),
                }, className: "ProgressBar" }))));
};
export var ProgressBarLast = function () { return (React.createElement("div", { className: "ProgressBarSectionLast sui-flex sui-flex-col sui-justify-center sui-align-center" },
    React.createElement("div", { className: "ProgressBarContainerLast" }))); };
